import config from 'src/config'
import _m from 'lodash/merge'
export default {
    props: {
        
        /**
         * Es administrador
         */
        isadmin: {
            type: Boolean,
            default: false
        },

        /**
         * Es subadministrador
         */
        issubadmin: {
            type: Boolean,
            default: false
        },

        /**
         * Es callcenter
         */
         iscallcenter: {
            type: Boolean,
            default: false
        },
         
         /**
         * Es traductor
         */
         istranslator: {
            type: Boolean,
            default: false
        },
         
        /**
         * Es comentarista
         */
         iscomment: {
            type: Boolean,
            default: false
        },

        /**
         * Es sub-administrador
         */
        isemail: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        currentNetwork: {
            handler() {

                if (!this.isComponentPage) {
                    return
                }
                
                if(this.currentNetwork){
                    
                    if (this.hasOwnProperty('step')) {
                        this.step.networkid = this.currentNetwork.uuid
                    }
                    if (this.hasOwnProperty('networkid')) {
                        this.networkid = this.currentNetwork.uuid
                    }
                    if (this.hasOwnProperty('form')) {
                        this.form.networkid = this.currentNetwork.uuid
                    }

                    this.$root.networkFound = this.currentNetwork
                }

                this.activeNetwork = this.currentNetwork ? false : true
                this.$root.activeNetwork = this.activeNetwork

                this.registerUrl   = this.currentNetwork ? this.currentNetwork.register && (this.currentNetwork.register != null && this.currentNetwork.register != '') ? this.uploadurl + this.currentNetwork.register + '?time=' + this.currentNetwork.time : this.imgurl : this.imgurl
                this.shareUrl      = this.currentNetwork ? this.currentNetwork.share && (this.currentNetwork.share != null && this.currentNetwork.share != '') ? this.uploadurl + this.currentNetwork.share + '?time=' + this.currentNetwork.time : this.imgurl : this.imgurl
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        captchaKey() {
          return config.captchaKey  
        },
        isComponentPage() {
          return this.$route.matched.some(r => r.instances.default == this)  
        },
        baseurl(){
            return config.url
        },
        imgurl(){
            return config.imgurl
        },
        homeurl(){
            return config.homeurl
        },
        uploadurl(){
            return config.uploadurl
        },
        profile() {
            return this.$root.profile
        },

        genericProfiles(){
            return [
                {
                    name: this.$t('CallCenter'),
                    uuid: 3
                },
                {
                    name: this.$t('Traductor'),
                    uuid: 5
                }
            ]
        },
        loginTo(){

            if(this.$route.query.invite){
                return '/login?invite=' + this.$route.query.invite
            }else{
                return '/login'
            }
        },
        gender(){ 
            return [
                {
                    text: this.$t('Masculino'),
                    id: 1
                },
                {
                    text: this.$t('Femenino'),
                    id: 0
                },
                {
                    text: this.$t('Otro'),
                    id: 2
                }
            ]
        },
        ages(){ 
            return [
                {
                    text: this.$t('0-20'),
                    id: 1
                },
                {
                    text: this.$t('21-30'),
                    id: 2
                },
                {
                    text: this.$t('31-40'),
                    id: 6 //Note: Nueva implementación
                },
                {
                    text: this.$t('41-60'),
                    id: 3
                },
                {
                    text: this.$t('61-80'),
                    id: 4
                },
                {
                    text: this.$t('Mayor a 80'),
                    id: 5
                }
            ]
        },
        minBirthdateDate(){
            return this.$moment().subtract(100, 'years').format('YYYY-MM-DD')
        },
        maxBirthdateDate() {
            let current = this.$moment()
            
            if (this.currentNetwork.adult) {
                current = current.subtract(18, 'years')
            }

            return current.format('YYYY-MM-DD')
        },
        conditionalNumber(){ 
            return [
                {
                    text: this.$t('Menor que'),
                    id: 'lt'
                },
                {
                    text: this.$t('Menor o igual que'),
                    id: 'lte'
                },
                {
                    text: this.$t('Mayor que'),
                    id: 'gt'
                },
                {
                    text: this.$t('Mayor o igual que'),
                    id: 'gte'
                },
                {
                    text: this.$t('Igual'),
                    id: 'eq'
                },
                {
                    text: this.$t('Entre'),
                    id: 'between'
                }
            ]
        },
        langsArr() {
            
            return [
                {
                    id: 'pt',
                    text: this.$t('Portugués')
                },
                {
                    id: 'en',
                    text: this.$t('Inglés')
                },
                {
                    id: 'it',
                    text: this.$t('Italiano')
                },
                {
                    id: 'fr',
                    text: this.$t('Francés')
                },
                {
                    id: 'de',
                    text: this.$t('Alemán')
                }
            ]
        },
        formValidationRules(){
            return [
                {
                    type: 'minlength',
                    label: this.$t('Mínimo de caracteres'),
                    value: 0
                },
                {
                    type: 'maxlength',
                    label: this.$t('Máximo de caracteres'),
                    value: 0
                },
                {
                    type: 'nowhitespaces',
                    label: this.$t('No permitir espacios en blanco'),
                },
                {
                    type: 'onlynumber',
                    label: this.$t('Solo números')
                }
            ]
        }
    },
    data() {
        return {
            availableRow  : [],
            currentNetwork: false,
            activeNetwork : false,
            shareUrl      : '',
            registerUrl   : '',
            logintext     : '',
            notfoundtext  : '',
            isgallery     : false,
            isbanner      : false,
        }
    },
    methods: {
        vFilter(item, queryText) {

            let name = item.name || item.names || item.text || item.label || item.placeholder || item.option || item.email
            
            if(name == undefined){
                name = ''
            }

            let text = name.toLowerCase()

            text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, '')
            
            let searchText = queryText != null ? queryText.toLowerCase() : ''
            return text.indexOf(searchText) > -1
        },
        vFilterEmail(item, queryText) {
          return this.vFilterKey('email', item, queryText)  
        },
        vFilterKey(key, item, queryText) {

            let value = item[key]
            
            if(value == undefined){
                value = ''
            }

            let text = value.toLowerCase()

            text = text.normalize("NFD").replace(/[\u0300-\u036f]/g, '')
            
            let searchText = queryText != null ? queryText.toLowerCase() : ''
            return text.indexOf(searchText) > -1
        },
        isAvailable(tag){
                
            if(!this.availableRow.length){
                return true
            }

            let row = this.availableRow.find((r) => r.tag == tag)

            if(!row){
                return true
            }

            return row.enable == 1 ? true : false
        },

        /**
         * Multiple selección
         */
        selectAll(data, key) {

            let ids = this[data].map((d) => d[key])
            this.multipleItems = ids
        },

        // Gestionar canales
        async handleChannel(cn, fn) {

            try{

                let ws = this.$ws
                ws.connect()

                this.$once('hook:beforeDestroy', () => {
                    ws.disconnect()
                })

                await ws.listener('connect').once()

                let profileid = this.$root.profile.uuid
                let channel   = profileid + cn

                let subscribedChannel = ws.subscribe(channel)
                await subscribedChannel.listener('subscribe').once()

                for await (let data of subscribedChannel){

                    let dat = JSON.parse(data)
                    fn(dat)
                }

            } catch (e) {
            }
        },

        hasAction(can, name){

            if(!this.profile.hasOwnProperty('can')){
                return true;
            }

            can = this.profile.can.find((c) => c.name == can)
            if(can == null){
                return false;
            }

            let data = can.data.find((c) => c.name == name)

            if(data == null){
                return false;
            }

            return data.default
        },

        isMobile() {
            
            let check = false
            let a = (navigator.userAgent || navigator.vendor || window.opera)
            
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                check = true
            }
            return check
        },

        goHome() {
            window.location.href = this.baseurl
        },

        async saveCurrentQuery(name) {
            
            let route = this.$route
            if (route.query.hasOwnProperty(name)) {
                
                let value = route.query[name]
                let query = Object.assign({}, route.query)
                
                if(name != 'invite'){
                    delete query[name]
                }
                
                await this.$setItem(name, value)

                this.$router.replace({
                    path  : route.path,
                    query : query
                })
            }
        },

        async saveCurrentRefCode(key = 'invite') {
            await this.saveCurrentQuery(key)
        },

        fetchConfig() {
            if (this.$route.name == 'login' || this.$route.name == 'register'  || this.$route.name == 'landing') {
                
                this.$api(this, (xhr) => {
                    xhr.get('/settings/logintext').then((r) => {
    
                        let data = r.data
                        if (data.response) {
                            this.logintext = data.data
                        }
                    }).catch(() => {})
                })
                
                this.$api(this, (xhr) => {
                    xhr.get('/settings/notfoundtext').then((r) => {
    
                        let data = r.data
                        if (data.response) {
                            this.notfoundtext = data.data
                        }
                    }).catch(() => {})
                })
            }
        },

        /**
         * Obtener label del perfil
         * 
         * @param {Number} profile Perfil 
         */
        profileLabel(profile){

            let label = this.genericProfiles.find(p => p.uuid == profile)
            return label != undefined ? label.name : ''
        },

        /**
         * Limpiar filtro
         */
        cleanFilter(){
            this.filter = _m({}, this.filterSchema)
        },

        /**
         * Error por defecto
         * 
         * @param {String} key Obtener error por defecto 
         */
        catchError(key){

            this[key + 'Msj'] = true
            this[key + 'Color'] = 'error'
            this[key + 'Text'] = this.$t('Ha orcurrido un error, intente de nuevo')
        },

        isNetwork(network){
            return !this.activeNetwork && Object.keys(this.currentNetwork).length ? network.includes(this.currentNetwork.alias) : false
        },

        isRequired(tag){

            if(!this.availableRow.length){
                return false
            }

            let row = this.availableRow.find((r) => r.tag == tag)

            if(!row){
                return false
            }

            return row.hasOwnProperty('required') ? (row.required == 1 ? true : false) : true
        },
    }
}